import { Routes } from "@/shared/constants";

/** Hrefs only — labels come from i18n `home.footer.*`. */
export const FOOTER_PRODUCT_HREFS: Record<string, string> = {
    ecosystem: Routes.TMA,
    create: "/auth?tab=register&next=/cabinet/create",
    tariffs: "/tariffs",
    knowledge: "/knowledge",
    games: "/games",
    about: Routes.ABOUTUS,
    support: Routes.PRODUCT_SUPPORT,
};

export const FOOTER_SOLUTION_HREFS: Record<string, string> = {
    horeca: "/solutions/horeca",
    beauty: "/solutions/beauty",
    retail: "/solutions/retail",
    fitness: "/solutions/fitness",
    services: "/solutions/services",
    realty: "/solutions/realty",
    "auto-sales": "/solutions/auto-sales",
    "auto-service": "/solutions/auto-service",
    all: Routes.SOLUTIONS,
};

export const FOOTER_PHONE = "+375 (33) 918-88-19";
export const FOOTER_PHONE_HREF = "tel:+375339188819";
export const FOOTER_TELEGRAM_HREF = "https://t.me/tezamchanel";
export const FOOTER_INSTAGRAM_HREF = "https://www.instagram.com/tezamteam/";

export const FOOTER_LEGAL = {
    policyHref: Routes.POLICY,
    paymentInfoHref: Routes.PAYMENT_AND_DELIVERY,
    offerHref: "/pub.pdf",
} as const;

/** @deprecated use i18n — kept for any stray imports */
export const FOOTER_TAGLINE =
    "Экосистема автоматизации бизнеса: Сайт + Telegram Mini App + CRM под ключ.";

export const FOOTER_PRODUCT_LINKS = [
    { label: "Экосистема Tezam", href: Routes.TMA },
    { label: "Создать сервис", href: "/auth?tab=register&next=/cabinet/create" },
    { label: "Тарифы", href: "/tariffs" },
    { label: "База знаний", href: "/knowledge" },
    { label: "О компании", href: Routes.ABOUTUS },
    { label: "Продуктовое сопровождение", href: Routes.PRODUCT_SUPPORT },
] as const;

export const FOOTER_SOLUTION_LINKS = [
    { label: "Кафе и рестораны", href: "/solutions/horeca" },
    { label: "Красота и уход", href: "/solutions/beauty" },
    { label: "Магазины и розница", href: "/solutions/retail" },
    { label: "Фитнес и занятия", href: "/solutions/fitness" },
    { label: "Услуги и сервис", href: "/solutions/services" },
    { label: "Недвижимость", href: "/solutions/realty" },
    { label: "Автобизнес", href: "/solutions/auto-sales" },
    { label: "Автосервис", href: "/solutions/auto-service" },
    { label: "Все направления", href: Routes.SOLUTIONS },
] as const;
